import{a as e}from"./chunk-RAAYCPUM.js";function a(...n){return e(t,n)}var t=(n,r)=>r>0?n.slice(0,Math.max(0,n.length-r)):[...n];export{a};
